export default "__VITE_ASSET__p8T59zsb__"